var _l;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PositionVariants as t } from "./index.es172.js";
var e = 8,
    r = 7,
    n = {
  x: 15,
  y: -4
},
    s = 4.5,
    f = {
  top: 0,
  left: 0,
  triangleOffset: {
    transform: "rotate(45deg)"
  }
},
    i = "225deg",
    O = "-45deg",
    d = "135deg",
    l = (_l = {}, _defineProperty(_l, t.aboveCenter, t.underCenter), _defineProperty(_l, t.underCenter, t.aboveCenter), _defineProperty(_l, t.aboveLeft, t.underLeft), _defineProperty(_l, t.aboveRight, t.underRight), _defineProperty(_l, t.underLeft, t.aboveLeft), _defineProperty(_l, t.underRight, t.aboveRight), _defineProperty(_l, t.left, t.right), _defineProperty(_l, t.right, t.left), _l),
    R = {
  transform: "--vds-tooltip-transform",
  top: "--vds-tooltip-top",
  left: "--vds-tooltip-left",
  right: "--vds-tooltip-right",
  bottom: "--vds-tooltip-bottom",
  triangleOffset: {
    transform: "--vds-tooltip-before-transform",
    top: "--vds-tooltip-before-top",
    left: "--vds-tooltip-before-left",
    right: "--vds-tooltip-before-right",
    bottom: "--vds-tooltip-before-bottom"
  }
},
    T = 250;
export { R as CSS_VARIABLES, f as DEFAULT_OFFSET, T as DELAY_BEFORE_SHOW_TOOLTIP, O as LEFT_ARROW, l as OPPOSITE_POSITION_VARIANTS, d as RIGHT_ARROW, e as TOOLTIP_X_OFFSET, r as TOOLTIP_Y_OFFSET, s as TRIANGLE_BORDER, n as TRIANGLE_OFFSETS, i as UP_ARROW };